import script from "./ProfileBackground.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileBackground.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileBackground.vue?vue&type=style&index=0&id=5c01ffdb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c01ffdb"]])

export default __exports__